import { css } from '@emotion/css';

/**
 * Custom CSS for a required field. This class will control the `textarea`
 * itself.
 */
const TEXTAREA_REQUIRED_CLASS: string = css`
  &::placeholder {
    color: transparent;
  }

  &:disabled + label,
  &:focus + label,
  &:valid + label {
    display: none;
  }
`;

/**
 * Calculates the field styles based on the `isDisabled`, `isRequired` and
 * `isRounded` properties.
 * @param {boolean} isDisabled - if `true`, it will have disable styles.
 * @param {boolean} isRequired - if `true`, it will have a custom red `*`.
 * @returns {{ [i: string]: boolean }} - class names object.
 */
export const getTextareaCSSProps = (
  isDisabled: boolean,
  isRequired: boolean,
): { [i: string]: boolean } => ({
  [TEXTAREA_REQUIRED_CLASS]: isRequired,
  'bg-gray-50 cursor-not-allowed opacity-70': isDisabled,
});

/**
 * Calculates the field dynamic styles based on the `color` parameter.
 * @param {string} color - hex., theme color.
 * @param {boolean} isDisabled - if `true`, will avoid to change the border
 * color on hover.
 * @returns {string} - primary dynamic styles.
 */
export const getDynamicCSS = (
  color: string,
  isDisabled: boolean,
): string => css`
  transition: all ease 0.2s;

  &:focus {
    border-color: ${color};
  }

  &:hover {
    border-color: ${isDisabled ? 'inherit' : color};
  }
`;
